// General
import "./ekyc-pending-dialog.scss";
import { forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateEkycPendingDialog } from "../../../../redux/store/dialogStore";
// Material UI
import { Dialog, Slide, useMediaQuery } from "@mui/material";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import AssetManager from "../../../utility/manager/asset-manager/asset-manager";

const EkycPendingDialog = () => {
  // Redux variables
  const ekycPendingDialog = useSelector(
    (state) => state.dialog.ekycPendingDialog
  );
  const dispatch = useDispatch();

  // MUI variables
  const isMobile = useMediaQuery("(max-width: 720px)");

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const getAsset = AssetManager();

  // Event Handlers | Dialog
  const onCloseDialog = () => {
    dispatch(updateEkycPendingDialog(false));
  };

  return (
    <Dialog
      className={
        isMobile ? "custom-bottom-sheet-no-radius-fullscreen-dialog" : ""
      }
      fullScreen={isMobile ? true : false}
      open={ekycPendingDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <div id="ekyc-pending-dialog">
        <div className="top-container">
          <div style={{ padding: "30px" }} />

          <div className="ekyc-icon-container">
            <img className="ekyc-icon" src={getAsset("ekycVerificationIcon")} />
          </div>

          <div style={{ padding: "10px" }} />

          <div className="title">
            {t("verification.ekyc.ekyc_pending_dialog.title")}
          </div>

          <div style={{ padding: "10px" }} />

          <div className="description">
            {t("verification.ekyc.ekyc_pending_dialog.description")}
          </div>
        </div>

        <div className="bottom-container">
          <div className="start-verification-button" onClick={onCloseDialog}>
            {t("common.done")}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default EkycPendingDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
